/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { Switch, Route } from 'react-router-dom';

import useReduxState from 'src/shared/app/base/hook/useReduxState';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { getRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import { getRouteHelp } from 'src/shared/app/base/route/util/routeUtils';
import HelpButton from 'src/shared/app/faq/component/HelpButton';

const HelpSwitch = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const state = useReduxState();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Switch>
      {getRoutes()
        .filter((route) => getRouteHelp(route, state))
        .map((route) => {
          // @TODO - really bad use of hook
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [path] = useRoutes(route);

          return (
            <Route
              path={path}
              exact
              render={() => <HelpButton />}
              // Use the same key to prevent re-renders when routes share the
              // same main component
              key={1}
            />
          );
        })}
    </Switch>
  );
};

export default compose(React.memo)(HelpSwitch);
